import React, {
	Component
} from 'react';
import { connect } from 'react-redux';
import { Tree, Tag,Input, Modal, Tabs, Checkbox, message, Button, Row, Icon } from 'antd';
import { PropTypes } from 'prop-types';
import axios from 'axios';
import API from '@/API/api';
import './styleTreeClassSelect.css'

const TabPane = Tabs.TabPane;
const {
	TreeNode
} = Tree;
const { Search } = Input;
class Relevance extends Component {
	static contextTypes = {
		router: PropTypes.object.isRequired
	};
	state = {
		tab: '',
		knows: new Map(),
		checkedKeys: [],
		commonSenseTree: [],
		AddKnowError: false, //增加前置知识点失败的知识点,
		searchValue: '',
		expandedKeys: [],
		autoExpandParent:true

	}

	componentDidMount() {
		let setState = {
			// tab: this.props.relate_id[0] ? this.props.relate_id[0].id : '0',
			tab: this.props.relate_id[0] ? this.props.relate_id[0].id : this.props.data.pre_type + '',
			knows: new Map()
		}
		this.props.relate_id &&
			this.props.relate_id.forEach((d) => {
				setState['selectedknows' + d.id] = []
			})
		this.setState(setState)
	}
	modalVisibleControl() {
		let modalEl = document.getElementsByClassName('ant-modal-content')[0]
		if(modalEl && this.props.visible) {
			modalEl.onmouseenter = function() {
				this.style.opacity = 1
			}
			modalEl.onmouseleave = function() {
				this.style.opacity = 0
			}
		}
	}

	componentWillReceiveProps(nextProps) {
		if(this.props.relate_id !== nextProps.relate_id) {
			let setState = {
				// tab: nextProps.relate_id[0] ? nextProps.relate_id[0].id : '0',
				tab: nextProps.relate_id[0] ? nextProps.relate_id[0].id : this.props.data.pre_type + '',
				knows: new Map()
			}
			nextProps.relate_id &&
				nextProps.relate_id.forEach((d) => {
					setState['selectedknows' + d.id] = []
				})
			//在这里初始化已经选中的knows内容
			nextProps.data.selected.forEach(v => {
				setState.knows.set(v.id, v)
			})
			setState.checkedKeys = Array.from(setState.knows.values()).map(v => v.id)

			this.setState(setState)

		}
	}
	componentDidUpdate(prevProps, prevState) {
		this.watchChange(this.state.tab, prevState.tab, () => {
			this.getTreeData()
		})
	}
	watchChange = (val, newVal, fn, data) => {
		if(val !== newVal) {
			fn(data)
		}
	}

	getTreeData = () => {
		if(!this.state['treeData' + this.state.tab]) {
			let data = {
				relate_id: this.state.tab,
				relate_type: this.props.data.type
			}
			let URL = API.QSELECTTNEW_TASK_QUESTION_NODE_TREE
			if(this.props.isTask === 'noTask') {
				URL = API.QSELECTTNEW_QUESTION_NODE_TREE
			}

			if(this.props.task_id) {
				data.task_id = this.props.task_id
			}

			axios.post(URL, data).then((res) => {
				res = res.data
				if(res.code === 0) {
					let treeList = res.data

					this.setState({
						['treeData' + this.state.tab]: treeList
					});
				} else {
					message.error(res.message);
				}
			}, (error) => {
				message.error('网络错误！');
			});
		}

	}
	addRelevance = async() => {
		if(this.props.okCallBackData) {
			let arr = []
			this.state.knows.forEach((d, key) => arr.push(key))
			if(arr.length) {
				let URL = this.props.okCallBackData.URL
				let data = {
					know_id: this.props.okCallBackData.know_id,
					pre_know_id: arr,
					is_add: this.props.okCallBackData.is_add,
				}
				let AddKnowError = false
				await axios.post(URL, data).then((res) => {
					res = res.data
					if(res.code === 0) {
						if(res.data.ring_know && res.data.ring_know.length > 0) {
							AddKnowError = AddKnowError || {}
							AddKnowError.ring_know = res.data.ring_know
						}
						if(res.data.relate_know && res.data.relate_know.length > 0) {
							AddKnowError = AddKnowError || {}
							AddKnowError.relate_know = res.data.relate_know
						}
					} else {
						message.error(res.message);
					}
				}, (error) => {
					message.error('网络错误！');
				});
				if(AddKnowError) { //有闭环的情况或直接关联知识点
					AddKnowError.relate_know && AddKnowError.relate_know.forEach(d => {
						this.state.knows.delete(d.know_id)
					})
					AddKnowError.ring_know && AddKnowError.ring_know.forEach(d => {
						this.state.knows.delete(d.know_id)
					})
					let selected = [...this.props.data.selected]
					this.state.knows.forEach((d, key) => {
						if(!selected.find(val => val.id == d.id)) {
							selected.push({
								name: d.name,
								id: d.id,
								well: '0'
							})
						}
					})
					this.props.data.selected = [...selected]
					this.setState({
						AddKnowError
					})
					return
				}
			}
			setTimeout(() => {
				this.props.okCallBackData.onOk()
			}, 0)
		}
		this.state.knows.forEach((d, key) => {
			if(!this.props.data.selected.find(val => val.id == d.id)) {
				this.props.data.selected.push({
					name: d.name,
					id: d.id,
					well: '0'
				})
			}
		})
		this.props.data.selected = [...this.props.data.selected]
		this.props.onOk()

	}
	onClick = (e, deep, item, know, selected) => {

		if(item.list && item.list.length) { //非末级选中
			let arr = this.state[selected];
			arr[deep] = item.id;
			arr.splice(deep + 1);
			this.setState({
				[selected]: arr
			})
		} else { //末级多选框选中
			let map = this.state[know]
			if(map.has(item.id)) {
				map.delete(item.id)
			} else {
				map.set(item.id, item)
			}
			this.setState({
				[know]: map
			})
		}

	}
	onCheck = (e, deep, item, know, selected) => {
		if(this.props.canSelectParentNode) {
			e.stopPropagation();
			let map = this.state[know]
			if(map.has(item.id)) {
				map.delete(item.id)
			} else {
				map.set(item.id, item)
			}
			this.setState({
				[know]: map
			})
		}

	}
	getDeep = (list) => {
		let resultDeep = 1
		const loop = (list, deep) => {
			list.forEach((d) => {
				if(resultDeep < deep) {
					resultDeep = deep
				}
				if(d.list) {
					loop(d.list, deep + 1)
				}
			})
		}
		loop(list, 1)
		return resultDeep
	}
	list = (list, current, deep, know, selected, base) => {
		return( 
			<div key = {deep} className = {'treeClassSelect'} style = {{width: (100 / this.getDeep(base) - 2) + '%'}} >
			 {
				list && list.map((item, key) =>
					<div key = {key} onClick = {(e) =>{this.onClick(e, deep, item, know, selected)}} className = {current === item.id ? 'active' : 'item'} > 
						
					{
						((!item.list || item.list.length === 0) || (this.props.canSelectParentNode)) &&
						<Checkbox onClick = {(e) => {this.onCheck(e, deep, item, know, selected)}} checked = {this.state[know].has(item.id)}/>	
					} 
					<lable style = {{padding: '0 5px'}} >{item.name} </lable>
					 </div>
					
				)
			} 
			</div>
		)
	}
	loopList = (list, current, deep = 0, know, selected, base = list) => { //know是已选的合集 selected是每层哪个被选中
		if(!list.length) {
			return null
		}
		if(this.state[selected][deep] == undefined && list[0].list && list[0].list.length) {
			current = current || list[0].id
			this.state[selected][deep] = list[0].id
		}

		let arr = []
		arr.push(this.list(list, current, deep, know, selected, base)) //一个选择框
		let next = list.find((val, key) => {
			return val.id === current
		})
		next = next && next.list
		if(next && next.length) {
			arr.push(
				this.loopList(next, this.state[selected][deep + 1], deep + 1, know, selected, base)
			)
		}
		return arr;

	}
	//文学常识选择
	renderTreeSelect(list) {
		const loopList = (data, parent_id) => {
			data.forEach(item => {
				item.parent_id = parent_id||'*'
				item.tmp_id=`${item.tmp_id}`
				if(item.list && item.list.length) {
					loopList(item.list, item.tmp_id)
				}
			})
		}
		//追加parent_id,tmp_id为唯一标识item.id#item.parent_id
		loopList(list)
		this.state.commonSenseTree = list
		//这里因为返回值this.props.data.selected不包含tmp_id 放弃回显选中
//		let checkedKeys = this.props.data.selected.map(v => `${v.id}#${v.parent_id}`)
		let checkedKeys=[]
		const loop = (data) =>
			data.map(item => {
				if(item.list && item.list.length) {
					return( <TreeNode disableCheckbox = {parseInt(item.id) <= 0} key = {item.tmp_id} title = {item.name} > 						
						{loop(item.list)}	
						 </TreeNode>
						
					);
				}
				return <TreeNode disableCheckbox = {parseInt(item.id) <= 0}  key = {item.tmp_id} title = {item.name}/>;
			});
		return( 
			<div>
			<Search style={{ marginBottom: 8,width:200}} placeholder="关键字" onChange={this.onSearchChange} />
			<Tree 
				checkable
				autoExpandParent={this.state.autoExpandParent}
				checkStrictly 
				onExpand={this.onExpand}
				expandedKeys={this.state.expandedKeys}
				checkedKeys={this.state.checkedKeys}
				defaultCheckedKeys = {checkedKeys}
				defaultExpandedKeys = {checkedKeys}
				onCheck = {this.onCheckNode} 
			>
			{loop(list)}	
			 </Tree>
			 </div>
			
		)

	}
	familyTree(arr1, id) {
		var temp = []
		var forFn = function(arr, id) {
			for(var i = 0; i < arr.length; i++) {
				var item = arr[i]
				if(item.tmp_id == id && ~~item.id > 0) {
					temp.push(item)
					if(item.parent_id) {
						forFn(arr1, item.parent_id)
					}

					break
				} else {
					if(item.list) {
						forFn(item.list, id)
					}
				}
			}
		}
		forFn(arr1, id)
		return temp
	}
	onCheckNode = (values, e) => {
//		console.log("values>>>",values,e)
		let item = {
			id: e.node.props.eventKey,
			name: e.node.props.title
		}
		//找出常识所有父节点，作为选中
		let parentNodes = this.familyTree(this.state.commonSenseTree, item.id)

		let map = this.state.knows
		
		parentNodes.forEach(v => {
			if(map.has(v.id) && item.id == v.tmp_id) {
				map.delete(v.id)
			} else {
				map.set(v.id, v)
			}
		})
		let checkedKeys = Array.from(this.state.knows.values()).map(v => v.tmp_id)

		this.setState({
			knows: map,
			checkedKeys
		})
//		console.log("knows", parentNodes ,this.state.knows, checkedKeys)
	}
	onSearchChange = e => {
	    const { value } = e.target
	    let expandedKeys = []
	    const loopList = (list) => {
			list.forEach(v => {
				if(v.name.indexOf(value) > -1){
	    				expandedKeys.push(v.tmp_id)
	    			}
				if(v.list&&v.list.length){
	    				loopList(v.list)
	    			}
			})
		}

	    loopList(this.state.commonSenseTree)
	    this.setState({
	      expandedKeys,
	      searchValue: value,
	      autoExpandParent:true
	    })
	 }
	 onExpand = expandedKeys => {
	    this.setState({
	      expandedKeys,
	      autoExpandParent: false,
	    });
	  };
	render() {
		// setTimeout(() => {
		// 	this.modalVisibleControl()
		// }, 1000)
		return( 
			<div>
			<Modal
				width = {1000}
				mask = {true}
				title = {`添加${this.props.data.title}关系`}
				visible = {this.props.visible}
				onOk = {this.addRelevance}
				onCancel = {() => {this.props.onCancel()}}
			>

			<Tabs activeKey = {this.state.tab} onChange = {(val) => {this.setState({	tab: val})}} > 
			{
				this.props.relate_id && this.props.relate_id.map((d, k) =>
					<TabPane tab = {this.props.pre_type > 0 ? d.name : ''} key = {d.id} >
					
					<div style = {{marginBottom: '15px'}} >
					<span > 已选： </span>
					<span >
					 {
						[...this.state.knows].map((val, key) =>
							<Tag key = {key} color = "#87d068" style = {{margin: '3px'}}>	
							 {val[1].name}
							 </Tag>
						)
					} 
					</span>
					</div> 
					<div >
					 {
						this.props.data.type != 31 && this.state['treeData' + d.id] &&
						this.loopList(this.state['treeData' + d.id], this.state['selectedknows' + d.id][0], 0, 'knows', 'selectedknows' + d.id)
					} {
						this.props.data.type == 31 && this.state['treeData' + d.id] &&
							this.renderTreeSelect(this.state[`treeData${d.id}`])

					} 
					</div>
					</TabPane>
				)
			}

			</Tabs> 
			</Modal>
			<Modal title = {'提示'} visible = {!!this.state.AddKnowError}
				onCancel = {() => {
					this.setState({
						AddKnowError: false
					})
				}}
				footer = {<div>
							<Button style = {{textAlign: 'center'}}	  onClick = {() => {this.setState({AddKnowError: false})}}> 确定 </Button>
						</div>}
			>	
			<Row className = "row" >
				<div > 您所选择的知识点有如下错误 </div>
			</Row> 
			<div style = {{margin: '20px 0'	}} > 
			{
				this.state.AddKnowError && this.state.AddKnowError.relate_know && this.state.AddKnowError.relate_know.map((item, k) =>
					<div style = {{margin: '10 0'}} key = {k} >
					<Icon type = "exclamation-circle" />
					<span style = {{fontSize: '13px'}} key = {item.know_id} >
					 {item.name}	
					 </span> 
					 <span> ，此知识点为直接关联知识点 </span>
					 </div>

				)
			} {
				this.state.AddKnowError && this.state.AddKnowError.ring_know && this.state.AddKnowError.ring_know.map((item, k) =>
					<div style = {{margin: '10 0'}} key = {k} >
					<Icon type = "exclamation-circle" />
					 <span style = {{fontSize: '13px'}} key = {item.know_id} > 
						{item.name}
					 </span>
					 <span> ，此知识点为闭环前置知识点 </span>
					 </div>
				)
			} 
			</div> 
			<Row className = "row" >	
			<div > 已勾选掉上述知识点 </div> 
			</Row> 
			</Modal>
			</div>
			
		)
	}
}

function mapState(state) {
	return {
		user: state.user,
	};
}

function mapDispatch(dispatch) {
	return {

	}
}
export default connect(mapState, mapDispatch)(Relevance);


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/set_tag/question_tag_detail/knowledge_box/treeClassSelect.js